import { Box } from '@superdispatch/ui-lab';
import { useCallback } from 'react';
import { useNavigate, useResolvedPath } from 'react-router-dom';
import { FormikDrawer } from 'shared/form/FormikDrawer';
import { ACHChangeBankDetailsBankInfoStep } from './ACHChangeBankDetailsBankInfoStep';
import { ACHChangeBankDetailsConfirmStep } from './ACHChangeBankDetailsConfirmStep';
import { ACHPaymentInfoDTO } from 'shared/modules/carrier-profile/data/CarrierProfileDTO';
import { useSearchParam } from 'shared/helpers/SearchParamsHelpers';
import { bypassNavigationPrompt } from 'shared/routing/NavigationBlock';

interface ACHChangeBankDetailsDrawerProps {
  isOpen: boolean;
  updatedPaymentInfo?: ACHPaymentInfoDTO;
  setUpdatedPaymentInfo: (updatedPaymentInfo: ACHPaymentInfoDTO) => void;
  onComplete: () => void;
}

export function ACHChangeBankDetailsDrawer({
  isOpen,
  updatedPaymentInfo,
  setUpdatedPaymentInfo,
  onComplete,
}: ACHChangeBankDetailsDrawerProps) {
  const navigate = useNavigate();
  const [step, setStep] = useSearchParam('step');
  const basePath = useResolvedPath('');

  const isConfirmStep = step === 'confirm';

  const onClose = useCallback(() => {
    navigate(basePath.pathname, { replace: true });
  }, [navigate, basePath.pathname]);

  return (
    <FormikDrawer open={isOpen} onClose={onClose}>
      <Box maxWidth={['initial', 'initial', '432px']}>
        {isConfirmStep && updatedPaymentInfo ? (
          <ACHChangeBankDetailsConfirmStep
            updatedPaymentInfo={updatedPaymentInfo}
            onClose={onClose}
            onComplete={() => {
              onComplete();
              onClose();
            }}
          />
        ) : (
          <ACHChangeBankDetailsBankInfoStep
            onClose={onClose}
            onContinue={(data) => {
              setUpdatedPaymentInfo(data);
              bypassNavigationPrompt(() => {
                setStep('confirm');
              });
            }}
          />
        )}
      </Box>
    </FormikDrawer>
  );
}
